import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeByIds } from '../../../thunk/favorites';
import { selectFilters, selectSelectedProducts } from '../../../selectors';
import { plural } from '@cian/utils';
import { ModalConfirm } from '../../../components/ModalConfirm';
import { ModalFooter, ModalRemoveFromFavoritesContent } from '../../../components/MassActions/remove';
import { trackRemoveConfirm } from './tracking';
import { EEntityType } from '../../../types/filters';
import { doNotShowModalRemoveFromFavorites } from '../../../utils/remove';

interface IProps {
  entityId?: number;
  onClose(): void;
}

export function ModalConfirmRemoveContainer({ entityId, onClose }: IProps) {
  const dispatch = useDispatch();

  const [doNotShow, setDoNotShow] = React.useState(false);
  const selectedProducts = useSelector(selectSelectedProducts);
  const { favoriteEntityType } = useSelector(selectFilters);
  const count = selectedProducts.length;

  const handleConfirm = () => {
    if (doNotShow) {
      doNotShowModalRemoveFromFavorites();
    }

    trackRemoveConfirm(selectedProducts);
    dispatch(removeByIds(entityId));
    onClose();
  };

  let confirmText;
  if (entityId) {
    confirmText = 'Удалить из избранного?';
  } else {
    confirmText = `Удалить ${count} ${plural(count, ['объявление', 'объявления', 'объявлений'])} из избранного?`;
  }

  return (
    <ModalConfirm
      text={confirmText}
      footer={<ModalFooter onConfirm={handleConfirm} onCancel={onClose} />}
      onClose={onClose}
      isVisible={true}
    >
      {favoriteEntityType !== EEntityType.Newbuilding && (
        <ModalRemoveFromFavoritesContent checked={doNotShow} onChange={checked => setDoNotShow(checked)} />
      )}
    </ModalConfirm>
  );
}
